import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ProjectDescription = ({ register }) => {
  return (
    <>
      <Form.Group>
        <Form.Label>
          Project Name <span style={{ color: 'red' }}>*</span>
        </Form.Label>
        <Form.Control
          type="text"
          name="name"
          {...register('name', {
            required: "You must input project's name."
          })}
        />
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="description"
          {...register('description')}
        />
      </Form.Group>
    </>
  );
};

ProjectDescription.propTypes = {
  register: PropTypes.func.isRequired
};

export default ProjectDescription;
